//import logo from './logo.svg';
//import './App.css';
import { BrowserRouter as Router, Route, Switch } from "react-router-dom";
import Empty from "./layouts/Empty";
import Layout from "./layouts/Layout";
import Home from "./pages/Home/Home";
//import Upload from './pages/Media/Upload';
import S3Upload from "./pages/S3Media/S3Upload";
import s3upload_tv9 from "./pages/S3Media/s3upload_tv9";
import Login from "./pages/Login";
import Logout from "./pages/Logout";
import Page404 from "./pages/Page404";
//import MediaList from './pages/Media/MediaList';
import S3MediaList from "./pages/S3Media/S3MediaList";

import AddPost from "./pages/Posts/AddPost";
import EditPost from "./pages/Posts/EditPost";
import PostList from "./pages/Posts/PostList";

// import AddStoryPost from "./pages/StoryPosts/AddStoryPost";
// import EditStoryPost from "./pages/StoryPosts/EditStoryPost";
// import StoryPostList from "./pages/StoryPosts/StoryPostList";

//--------------------------Admin Section Starts-----------------------------
import AddUser from "./pages/Admin/Users/AddUser";
import EditUser from "./pages/Admin/Users/EditUser";
import UserList from "./pages/Admin/Users/UserList";
// import UserReport from "./pages/Admin/Users/UserReport";

import AddCity from "./pages/Admin/Masters/AddCity";
import EditCity from "./pages/Admin/Masters/EditCity";
import CityList from "./pages/Admin/Masters/CityList";
// -------------------------Admin Section Ends---------------------------

// import AddBreaking from "./pages/Breakings/AddBreaking";
// import EditBreaking from "./pages/Breakings/EditBreaking";
// import BreakingList from "./pages/Breakings/BreakingList";
// 
// import AddVideostory from "./pages/Videostory/AddVideostory";
// import EditVideostory from "./pages/Videostory/EditVideostory";
// import VideostoryList from "./pages/Videostory/VideostoryList";
// 
// import AddPhotogallery from "./pages/Photogallery/AddPhotogallery";
// import EditPhotogallery from "./pages/Photogallery/EditPhotogallery";
// import PhotogalleryList from "./pages/Photogallery/PhotogalleryList";
// 
// import AddAssignment from "./pages/Assignments/AddAssignment";
// import EditAssignment from "./pages/Assignments/EditAssignment";
// import AssignmentList from "./pages/Assignments/AssignmentList";

import AddIdea from "./pages/Ideas/AddIdea";
import EditIdea from "./pages/Ideas/EditIdea";
import IdeaList from "./pages/Ideas/IdeaList";

import Register from "./pages/Register";
import Forgot from "./pages/Forgot";
import Reset from "./pages/Reset";

import AddRole from "./pages/Admin/Roles/AddRole";
import EditRole from "./pages/Admin/Roles/EditRole";
import RoleList from "./pages/Admin/Roles/RoleList";

import AddPermission from "./pages/Admin/Roles/AddPermission";
import EditPermission from "./pages/Admin/Roles/EditPermission";
import PermissionList from "./pages/Admin/Roles/PermissionList";

import AddRolePermission from "./pages/Admin/Roles/AddRolePermission";
import EditRolePermission from "./pages/Admin/Roles/EditRolePermission";
import RolePermissionList from "./pages/Admin/Roles/RolePermissionList";

const AppRoute = ({ component: Component, layout: Layout, ...rest }) => (
  <Route
    {...rest}
    render={(props) => (
      <Layout
        accessType={rest.accessType}
        pagename={rest.pagename}
        breadcrumb={rest.breadcrumb}
      >
        <Component {...props} />
      </Layout>
    )}
  ></Route>
);


function App() {
  if (!process.env.NODE_ENV || process.env.NODE_ENV === "development") {
    localStorage.setItem("basurl", "http://127.0.0.1:5000");
  } else {
    localStorage.setItem("basurl", "https://mojoapis.tv9.com");
  }
  localStorage.setItem(
    "baseimageurlold",
    "https://mojo-tv9.s3.ap-south-1.amazonaws.com"
  );
  //localStorage.setItem("baseimageurl", "https://d2f49vw9ejrqc0.cloudfront.net");
  localStorage.setItem("baseimageurl", "https://dlgoo6udmxfsz.cloudfront.net");
  return (
    <>
      <Router>
        <Switch>
          <AppRoute
            path="/"
            pagename="Home"
            breadcrumb={[{ name: "Home", path: "/" }]}
            exact
            layout={Layout}
            component={Home}
            accessType="logedin"
          />
          <AppRoute
            path="/login"
            pagename="Login"
            layout={Empty}
            component={Login}
            accessType="public"
          />
          <AppRoute
            path="/register"
            pagename="Register"
            layout={Empty}
            component={Register}
            accessType="public"
          />
          <AppRoute
            path="/logout"
            pagename="Logout"
            layout={Empty}
            component={Logout}
            accessType="public"
          />

          <AppRoute
            path="/forgot"
            pagename="Forgot Password"
            layout={Empty}
            component={Forgot}
            accessType="public"
          />
          <AppRoute
            path="/reset/:token"
            pagename="Reset Password"
            layout={Empty}
            component={Reset}
            accessType="public"
          />

          {/* <AppRoute path="/media" pagename="Media" breadcrumb={[{name:'Home', path:'/'}, {name:'Media', path:''}]} exact layout={Layout} component={MediaList} accessType="logedin"/>
        <AppRoute path="/media/upload" pagename="Upload Media"  breadcrumb={[{name:'Home', path:'/'}, {name:'Media', path:'/media'},{name:'Upload Media', path:''}]} layout={Layout} component={Upload} accessType="logedin"/> */}

          <AppRoute
            path="/s3media"
            pagename="Media"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Media", path: "" },
            ]}
            exact
            layout={Layout}
            component={S3MediaList}
            accessType="logedin"
          />
          <AppRoute
            path="/s3media/s3upload"
            pagename="Upload Media"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Media", path: "/s3media" },
              { name: "Upload Media", path: "" },
            ]}
            layout={Layout}
            component={S3Upload}
            accessType="logedin"
          />
		  
		  <AppRoute
            path="/s3media/s3upload_tv9"
            pagename="Upload Media TV9"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Media", path: "/s3media" },
              { name: "Upload Media TV9", path: "" },
            ]}
            layout={Layout}
            component={s3upload_tv9}
            accessType="logedin"
          />

          <AppRoute
            path="/posts"
            pagename="Posts"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Posts", path: "" },
            ]}
            exact
            layout={Layout}
            component={PostList}
            accessType="logedin"
          />
          <AppRoute
            path="/posts/add-post"
            pagename="Add Post"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Posts", path: "/posts" },
              { name: "Add Post", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddPost}
            accessType="logedin"
          />
          <AppRoute
            path="/posts/update-post/:id"
            pagename="Update Post"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Posts", path: "/posts" },
              { name: "Edit Post", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditPost}
            accessType="logedin"
          />

          <AppRoute
            path="/posts"
            pagename="Posts"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Posts", path: "" },
            ]}
            exact
            layout={Layout}
            component={PostList}
            accessType="logedin"
          />

         
          
          
          <AppRoute
            path="/ideas"
            pagename="Ideas"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Ideas", path: "" },
            ]}
            exact
            layout={Layout}
            component={IdeaList}
            accessType="logedin"
          />
          <AppRoute
            path="/ideas/add-idea"
            pagename="Add Idea"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Ideas", path: "/ideas" },
              { name: "Add Ideas", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddIdea}
            accessType="logedin"
          />
          <AppRoute
            path="/ideas/update-idea/:id"
            pagename="Update Idea"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Ideas", path: "/ideas" },
              { name: "Edit Idea", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditIdea}
            accessType="logedin"
          />

          {/* --------------------- Admin Section Starts-------------------------- */}

          <AppRoute
            path="/admin/users"
            pagename="Users"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Users", path: "/admin/users" },
            ]}
            exact
            layout={Layout}
            component={UserList}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/add-user"
            pagename="Add User"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Users", path: "/admin/users" },
              { name: "Add User", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddUser}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/update-user/:id"
            pagename="Update User"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Users", path: "/admin/users" },
              { name: "Edit User", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditUser}
            accessType="logedin"
          />

          

          <AppRoute
            path="/masters/cities"
            pagename="Cities"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Cities", path: "/admin/Cities" },
            ]}
            exact
            layout={Layout}
            component={CityList}
            accessType="logedin"
          />
          <AppRoute
            path="/masters/add-city"
            pagename="Add City"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Cities", path: "/masters/cities" },
              { name: "Add City", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddCity}
            accessType="logedin"
          />
          <AppRoute
            path="/masters/update-city/:id"
            pagename="Update City"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Cities", path: "/admin/cities" },
              { name: "Edit City", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditCity}
            accessType="logedin"
          />

          <AppRoute
            path="/admin/roles"
            pagename="Roles"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Roles", path: "/admin/roles" },
            ]}
            exact
            layout={Layout}
            component={RoleList}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/roles/add-role"
            pagename="Add Role"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Roles", path: "/admin/roles" },
              { name: "Add Role", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddRole}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/roles/update-role/:id"
            pagename="Update Role"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Roles", path: "/admin/roles/update-role" },
              { name: "Edit Role", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditRole}
            accessType="logedin"
          />

          <AppRoute
            path="/admin/permissions"
            pagename="Permissions"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Permissions", path: "/admin/permissions" },
            ]}
            exact
            layout={Layout}
            component={PermissionList}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/permissions/add-permission"
            pagename="Add Permission"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "Permissions", path: "/admin/permissions" },
              { name: "Add Permission", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddPermission}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/permissions/update-permission/:id"
            pagename="Update Permission"
            breadcrumb={[
              { name: "Home", path: "/" },
              {
                name: "Permissions",
                path: "/admin/permissions/update-permission",
              },
              { name: "Edit Permission", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditPermission}
            accessType="logedin"
          />

          <AppRoute
            path="/admin/rolespermissions"
            pagename="RolesPermissions"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "RolesPermissions", path: "/admin/rolespermissions" },
            ]}
            exact
            layout={Layout}
            component={RolePermissionList}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/rolespermissions/add-rolepermission"
            pagename="Add RolePermission"
            breadcrumb={[
              { name: "Home", path: "/" },
              { name: "RolesPermissions", path: "/admin/rolespermissions" },
              { name: "Add RolePermission", path: "" },
            ]}
            exact
            layout={Layout}
            component={AddRolePermission}
            accessType="logedin"
          />
          <AppRoute
            path="/admin/rolespermissions/update-rolepermission/:id"
            pagename="Update RolePermission"
            breadcrumb={[
              { name: "Home", path: "/" },
              {
                name: "RolesPermissions",
                path: "/admin/rolespermissions/update-rolepermission",
              },
              { name: "Edit RolePermission", path: "" },
            ]}
            exact
            layout={Layout}
            component={EditRolePermission}
            accessType="logedin"
          />

          {/* --------------------- Admin Section Ends-------------------------- */}

          <Switch>
            <AppRoute
              path="*"
              pagename="404"
              exact
              layout={Empty}
              component={Page404}
              status={404}
              accessType="public"
            />
          </Switch>
        </Switch>
      </Router>
    </>
  );
}
export default App;
